import ReactGA from 'react-ga';
ReactGA.initialize(process.env.REACT_APP_GOOGLE);

export const analitycEvent = (category = '', action = '', label = '') => {
    ReactGA.event({
        category,
        action,
        label
      });
}